/**
 * Simple Modal Components with HeroUI-like theming
 *
 * This module provides a complete modal system with comprehensive theming
 * that follows HeroUI patterns and conventions.
 */

// Main components
export {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from './simple-modal';

// Theme system
export {
  simpleModalTheme,
  useSimpleModalTheme,
  type SimpleModalVariantProps,
  type SimpleModalSlots,
} from './simple-modal-theme';

// Utilities and helpers
export {
  modalThemePresets,
  getModalPreset,
  mergeModalTheme,
  modalClassNames,
  modalAnimations,
  createThemedModal,
  getResponsiveSize,
  detectDarkMode,
  type ModalPreset,
  type ModalClassNames,
  type ModalAnimation,
} from './simple-modal-utils';

// Examples (for development/documentation)
export { default as SimpleModalExamples } from './simple-modal-examples';

/**
 * Usage Examples:
 *
 * // Basic usage
 * import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from './path/to/simple-modal';
 *
 * // With theme
 * <Modal variant="primary" size="lg" backdrop="blur">
 *   <ModalContent>
 *     <ModalHeader>Title</ModalHeader>
 *     <ModalBody>Content</ModalBody>
 *     <ModalFooter>Actions</ModalFooter>
 *   </ModalContent>
 * </Modal>
 *
 * // Using presets
 * import { getModalPreset } from './path/to/simple-modal';
 * const confirmationProps = getModalPreset('confirmation');
 *
 * // Custom theme merging
 * import { mergeModalTheme } from './path/to/simple-modal';
 * const customTheme = mergeModalTheme('form', { variant: 'primary' });
 */
